import api from '@/api/Api'

export const state = {
}

export const getters = {
  detectionForm (state) {
    return state.form
  }
}

export const mutations = {

}
export const actions = {
  rated ({ commit, state, rootState }) {
    return api.onRated().then((response) => {
      return response
    })
  },
  rating ({commit, state, rootState}, form) {
    return api.onRating(form).then((response) => {
      return response
    })
  }
}



// WEBPACK FOOTER //
// ./src/state/modules/rate.js